import { httpRequest } from '@/request';
import { getServerUrl } from '@/request/config';

export default {
  getListCountry: ({ root }) => {
    return httpRequest({
      url: getServerUrl('STORE', '/meta/location/listCountry', root),
    });
  },

  getListPhoneCode: ({ root }) => {
    return httpRequest({
      url: getServerUrl('STORE', '/user/delivery/listPhoneCode', root),
    });
  },

  getSpecificationsDetail: ({ CountryCode, X_Language, root, productId }) => {
    return httpRequest({
      url: getServerUrl('POINT', '/point/service/mall/product/getSpecificationsDetail', root),
      CountryCode,
      X_Language,
      instaToken: true,
      params: {
        productId,
      },
    });
  },

  exchangePhysicalProduct: ({ CountryCode, X_Language, root, data }) => {
    return httpRequest({
      url: getServerUrl('POINT', '/point/service/mall/product/exchangePhysicalProduct', root),
      CountryCode,
      X_Language,
      method: 'post',
      instaToken: true,
      data,
    });
  },
};
